import { FunctionComponent } from 'react';
import { Star } from './icons/Star';

interface Props {
  rating?: number;
  maxRating: number;
}

export const Rating: FunctionComponent<Props> = ({ rating, maxRating }) => {
  if (!rating) {
    return null;
  }

  const fixedRating = rating % 1 > 0.75 ? Math.round(rating) : rating;
  const filledStarCount = Math.floor(fixedRating);
  const emptyStarCount = Math.max(0, maxRating - Math.ceil(fixedRating));
  const needsHalfStar = Math.ceil(fixedRating) !== fixedRating;

  const filledElements = new Array(filledStarCount)
    .fill(null)
    .map((_, index) => <Star type="filled" key={index} />);
  const emptyElements = new Array(emptyStarCount)
    .fill(null)
    .map((_, index) => <Star type="default" key={filledStarCount + index} />);
  const ratingElements = [
    ...filledElements,
    needsHalfStar ? <Star type="half-filled" key="half-star" /> : null,
    ...emptyElements,
  ];

  return <>{ratingElements}</>;
};
